window.ucllbGetBreakpoints = () => {
	if( window.UCLL && ( 'function' === typeof window.UCLL.tailwindBreakpoints.get ) ){
		return window.UCLL.tailwindBreakpoints.get();
	}
	return {};
}

window.ucllbGetBreakpointsPx = () => {
	if( window.UCLL && ( 'function' === typeof window.UCLL.tailwindBreakpoints.getPx ) ){
		return window.UCLL.tailwindBreakpoints.getPx();
	}
	return {};
}